/**
 * How a RADIO or MULTI_SELECT field lays out its choices. Mirrors the Kotlin `ChoiceLayout` enum.
 * Null/absent means VERTICAL, one choice per line; HORIZONTAL lines them up and wraps.
 */
export enum ChoiceLayout {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL'
}
